import { render, staticRenderFns } from "./DashboardConfig.vue?vue&type=template&id=e1723c40&scoped=true"
import script from "./DashboardConfig.vue?vue&type=script&lang=js"
export * from "./DashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./DashboardConfig.vue?vue&type=style&index=0&id=e1723c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1723c40",
  null
  
)

export default component.exports